import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReelCuttingModalComponent } from '../reel-cutting-modal/reel-cutting-modal.component';

@Component({
  selector: 'py-reel-cutting-wrapper',
  templateUrl: './reel-cutting-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReelCuttingModalComponent],
})
export class ReelCuttingWrapperComponent {
  constructor() {}
}
